import dayjs from 'dayjs';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, WMS_MODULE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const SortingList = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.number, show: false, showCopyButton: true },
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.string,
				showOnMobile: true,
				showCopyButton: true
			},
			{
				Header: 'orderDate',
				accessor: 'orderDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				filterRemovable: false
			},
			{
				Header: 'packingStatus',
				accessor: 'packingStatus',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PACKING_STATUS
			},
			{
				Header: 'sortingStatus',
				accessor: 'sortingStatus',
				enumName: ENUMS.SORTING_STATUS,
				filterType: FilterType.enumMulti
			},
			{
				Header: 'binName',
				accessor: 'sortingBinName',
				filterType: FilterType.string
			},

			{
				Header: 'percentage',
				accessor: 'progress',
				filterType: FilterType.float,
				renderCell: ListComponents.PERCENTAGE
			}
		],
		[]
	);

	const defaultFilters = useMemo(
		() => [
			{
				column: columns.find((col) => col.accessor === 'orderDate'),
				action: FilterAction.between,
				value: {
					start: dayjs().subtract(30, 'day').endOf('day').toISOString(),
					end: dayjs().endOf('day').toISOString()
				}
			}
		],
		[]
	);

	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);
	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.SORTING_LIST}
				defaultSort={defaultSort}
				columns={columns}
				fetchUrl={WMS_MODULE.GET_SORTING_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.WMS}
				exportName="sortingList"
				defaultFilters={defaultFilters}
			/>
		</TabTableContainer>
	);
};

export default SortingList;
